import { render, staticRenderFns } from "./LabelAvaliationItemStrategy.vue?vue&type=template&id=25e3b8a0"
import script from "./LabelAvaliationItemStrategy.vue?vue&type=script&lang=js"
export * from "./LabelAvaliationItemStrategy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports